export const DISPLAY_ALT_CHARGES = 'DISPLAY_ALT_CHARGES';
export const SET_ALT_CHARGES = 'SET_ALT_CHARGES';
